import React, { useState } from "react";
import {
  Button,
  FormGroup,
  Classes,
  Dialog,
  InputGroup,
  Callout,
  Intent
} from "@blueprintjs/core";
import { UpdateAccountEmail } from "./mutation";
import { useMutation } from "@apollo/react-hooks";
import { isEmail } from "validator";
import DefaultToaster from "../../../atoms/DefaultToaster";
import FormInfo from "../../../atoms/FormInfo/FormInfo";

function EmailInput({ email, onUpdate }) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [updateEmail] = useMutation(UpdateAccountEmail);
  const [newEmail, setNewEmail] = useState("");
  const [confirmEmail, setConfirmEmail] = useState("");
  const [error, setError] = useState();

  async function handleSubmit(e) {
    e.preventDefault();

    if (isEmail(newEmail.trim()) && newEmail.trim() === confirmEmail.trim()) {
      await updateEmail({
        variables: {
          email: newEmail.trim()
        }
      });

      onUpdate(newEmail.trim());
      setIsDialogOpen(false);

      DefaultToaster.show({
        message: "Your email has been updated!",
        icon: "tick",
        intent: Intent.SUCCESS
      });
    } else {
      setError({
        title: "Invalid Email.",
        message: "Please enter a valid email address."
      });
    }
  }

  function closeDialog() {
    setIsDialogOpen(false);
    setNewEmail("");
    setConfirmEmail("");
    setError(undefined);
  }

  return (
    <>
      <Dialog
        icon="lock"
        onClose={closeDialog}
        title="Change Email Address"
        isOpen={isDialogOpen}
      >
        <form onSubmit={handleSubmit}>
          <div className={Classes.DIALOG_BODY}>
            <FormInfo>
              Enter a new email address that you'd like to associate with your
              Video Squirrel account for login, receipts, account, and marketing
              emails. You will no longer be able to log in with <b>{email}</b>.
            </FormInfo>

            {error && (
              <Callout
                title={error.message}
                intent={Intent.DANGER}
                icon="error"
              />
            )}

            <FormGroup label="New Email" labelFor="newEmail">
              <InputGroup
                id="newEmail"
                type="email"
                autoCapitalize="none"
                autoCorrect="false"
                value={newEmail}
                onChange={(e) => setNewEmail(e.target.value)}
              />
            </FormGroup>
            <FormGroup label="Confirm Email" labelFor="confirmEmail">
              <InputGroup
                id="confirmEmail"
                type="email"
                autoCapitalize="none"
                autoCorrect="false"
                value={confirmEmail}
                onChange={(e) => setConfirmEmail(e.target.value)}
              />
            </FormGroup>
          </div>
          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button onClick={closeDialog} type="button" minimal>
                Cancel
              </Button>
              <Button type="submit" intent={Intent.PRIMARY}>
                Confirm
              </Button>
            </div>
          </div>
        </form>
      </Dialog>

      <FormGroup label="Email">
        <InputGroup
          value={email}
          readOnly
          rightElement={
            <Button text="Update" onClick={() => setIsDialogOpen(true)} />
          }
        />
      </FormGroup>
    </>
  );
}

export default EmailInput;
